import { createStyles, Theme } from '@mui/material';
import { MaxThumbnailHeight, MaxThumbnailWidth } from 'assets/jss/common-styles';

const gutter = {
    small: 2,
    large: 4,
};

export const Styles = (theme: Theme) => createStyles({

    gallery: {
        marginRight: -gutter.small,
        overflow: 'hidden',

        '@media (min-width: 500px)': {
            marginRight: -gutter.large,
        },
        textAlign: 'center',
        lineHeight: '118px'
    },

    // anchor
    thumbnail: {
        boxSizing: 'border-box',
        display: 'block',
        float: 'left',
        lineHeight: 0,
        paddingRight: gutter.small,
        paddingBottom: gutter.small,
        overflow: 'hidden',
        height: MaxThumbnailHeight,
        width: MaxThumbnailWidth,

        '@media (min-width: 500px)': {
            paddingRight: gutter.large,
            paddingBottom: gutter.large,
        },

        "& img": {
            maxHeight: "100%",
            maxWidth: "100%",
            cursor: "zoom-in"
        }

    },

    // orientation
    landscape: {
        width: '30%',
    },
    square: {
        paddingBottom: 0,
        width: '40%',

        '@media (min-width: 500px)': {
            paddingBottom: 0,
        },
    },

    // actual <img />
    source: {
        border: 0,
        display: 'block',
        height: 'auto',
        maxWidth: '100%',
        width: 'auto',
    },
});

